import { graphql } from 'gql';

export const catalogOtherCostVariableGql = graphql(`
    query catalogOtherCostVariable($otherCostVariableId: Long!) {
        catalogOtherCostVariable(otherCostVariableId: $otherCostVariableId) {
            data {
                dataSource {
                    id
                    name
                }
                entities {
                    name
                    uniqueId
                }
                formula
                group {
                    id
                    name
                }
                name
                type
                otherCostTypeId
                limitedCostTypeId
            }
        }
    }
`);

export const catalogOtherCostVariableEntitiesGql = graphql(`
    query catalogOtherCostVariableEntities(
        $methodology: ProjectMethodologyEnum!
        $where: CatalogOtherCostVariableEntityItemDataFilterInput
        $order: [CatalogOtherCostVariableEntityItemDataSortInput!]
    ) {
        catalogOtherCostVariableEntities(methodology: $methodology, where: $where, order: $order) {
            name
            uniqueId
        }
    }
`);

export const isUniqueVariableNameGql = graphql(`
    query isUniqueVariableName(
        $catalogUniqueId: String!
        $variableId: Long
        $variableType: CatalogOtherCostVariableTypeEnum!
        $variableName: String!
        $globalOnly: Boolean!
        $methodology: ProjectMethodologyEnum!
    ) {
        isUniqueVariableName(
            catalogUniqueId: $catalogUniqueId
            variableId: $variableId
            variableType: $variableType
            variableName: $variableName
            globalOnly: $globalOnly
            methodology: $methodology
        ) {
            result
        }
    }
`);

export const createCatalogOtherCostVariableGql = graphql(`
    mutation createCatalogOtherCostVariable($input: CatalogOtherCostVariableCreateInput!) {
        createCatalogOtherCostVariable(input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const updateCatalogOtherCostVariableGql = graphql(`
    mutation updateCatalogOtherCostVariable($input: CatalogOtherCostVariableUpdateInput!) {
        updateCatalogOtherCostVariable(input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const catalogOtherCostVariableDataSourcesGql = graphql(`
    query catalogOtherCostVariableDataSources(
        $entityUniqueIds: [String!]
        $methodology: ProjectMethodologyEnum!
        $order: [CatalogOtherCostVariableDataSourceItemDataSortInput!]
    ) {
        catalogOtherCostVariableDataSources(
            entityUniqueIds: $entityUniqueIds
            methodology: $methodology
            order: $order
        ) {
            items {
                id
                name
            }
        }
    }
`);

export const globalConstructionTypes = graphql(`
    query globalConstructionTypes(
        $where: ConstructionTypeDataFilterInput
        $skip: Int
        $take: Int
        $order: [ConstructionTypeDataSortInput!]
    ) {
        globalConstructionTypes(where: $where, take: $take, skip: $skip, order: $order) {
            totalCount
            items {
                code
                id
                name
                shortName
                catalogId
                fullName
                contractFileName
                createdAt
            }
        }
    }
`);
